import { useMemo } from "react";
import { Modal } from "react-bootstrap";
import styles from '../Market.module.css';
import { OpDataGrid } from "op2mise-react-widgets";
import Button from "shared/components/button/Button";
import MarketStorage from "../MarketStorage";

const StationAndCableListModal = ({
    show,
    onHide,
    marketName,
    list,
}) => {
    const columnDefs = useMemo(() => {
        return [
            { field: 'code', headerName: 'STATION/CABLE' },
            { field: 'network', headerName: 'NETWORK/PROVIDER' },
            { field: 'name', headerName: 'ZONE' },
            { field: 'target', headerName: 'TARGET' },
            { field: 'networkType', headerName: 'TYPE'}
        ];
    }, []);

    return (
        <Modal centered show={show} onHide={onHide} dialogClassName={styles.stationsAndCablesModal}>
            <div className={styles.stationWrapper}>
                <p className={styles.stationsAndCablesModalTitle}>{marketName} - Stations and Cables</p>
                <OpDataGrid
                    columns={columnDefs}
                    customVerbiage={'No stations/cables found'}
                    defaultSort={{
                        field: 'code',
                        sort: 'asc',
                    }}
                    gridHeightBuffer={500}
                    gridName={'mp-data-management-markets-station-cables-view'}
                    resizable={true}
                    rows={list}
                    sharedColumnProperties={{
                        filter: { fields: MarketStorage.stationAndCablesHeaders, value: true },
                        flex: { fields: MarketStorage.stationAndCablesHeaders, value: 1 },
                        sortable: { fields: MarketStorage.stationAndCablesHeaders, value: true },
                    }}
                    showAlternativeRowHighlight
                    suppressRowClickSelection={true}
                />

                <Button
                    text={'Close'}
                    onClick={onHide}
                    style={{ float: 'right', marginTop: '25px' }}
                />
            </div>
        </Modal>
    )
};

export default StationAndCableListModal;